import React, { useState } from 'react';
import '../css/progressBar.css'

const ProgressBar = () => {

    const [activity, setActivity] = useState(0);

    const setNextActivity = () =>{
        setActivity(activity+1);
    }

    return (
        <>
            <div className='progress-bar-section'>
                <div class="progress-track"></div>

                <div className='completed-tracks'>
                    <div id='track-1' class={activity > 1 ? 'completed-track' : 'hidden'}></div>
                    <div id='track-2' class={activity > 2 ? 'completed-track' : 'hidden'}></div>
                    <div id='track-3' class={activity > 3 ? 'completed-track' : 'hidden'}></div>
                    <div id='track-4' class={activity > 4 ? 'completed-track' : 'hidden'}></div>
                    <div id='track-5' class={activity > 5 ? 'completed-track' : 'hidden'}></div>
                </div>
                
                <div className='lt-btn-wrapper' >
                    <div className={activity >=1 ? 'lab-test-activity lt-active' : 'lab-test-activity'}>
                        1
                    </div>
                    <div className='activity-desc'>
                        Activity name
                    </div>
                </div>


                <div className='lt-btn-wrapper' >
                    <div className={activity >=2 ? 'lab-test-activity lt-active' : 'lab-test-activity'}>
                        2
                    </div>
                    <div className='activity-desc'>
                        Activity name
                    </div>
                </div>


                <div className='lt-btn-wrapper' >
                    <div className={activity >=3 ? 'lab-test-activity lt-active' : 'lab-test-activity'}>
                        3
                    </div>
                    <div className='activity-desc'>
                        Activity name
                    </div>
                </div>
                <div className='lt-btn-wrapper' >
                    <div className={activity >=4 ? 'lab-test-activity lt-active' : 'lab-test-activity'}>
                        4
                    </div>
                    <div className='activity-desc'>
                        Activity name
                    </div>
                </div>
                <div className='lt-btn-wrapper' >
                    <div className={activity >=5 ? 'lab-test-activity lt-active' : 'lab-test-activity'}>
                        5
                    </div>
                    <div className='activity-desc'>
                        Activity name
                    </div>
                </div>
                <div className='lt-btn-wrapper' >
                    <div className={activity >=6 ? 'lab-test-activity lt-active' : 'lab-test-activity'}>
                        6
                    </div>
                    <div className='activity-desc'>
                        Activity name
                    </div>
                </div>
            </div>
            <button onClick={setNextActivity}>Siguiente</button>
        </>
    );
}

export default ProgressBar;
